// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { RouteIcon } from '@moia-dev/pace-icons'
import { DemoRoutesAreaRoutes } from './DemoRoutesAreaRoutes'

export const DemoRoutesAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={DemoRoutesAreaRoutes.route}
      Icon={RouteIcon}
    />
  )
}
